import { clarity } from 'react-microsoft-clarity';
import TokenService from '../Token';
import { getLocalDateString } from '../../utils/dateTimeHelper';

export const initializeClarity = async () => {
  const clarityKey = process.env.REACT_APP_CLARITY_KEY;

  if (clarityKey) {
    clarity.init(
      clarityKey,
    );
  } else {
    console.log('Clarity key not found');
  }
};

export const setClarityUserId = (personId: number) => {
  // clarity.setTag('user', personId.toString());
  
  // Check if Clarity has been initialized before calling its methods
  if (clarity.hasStarted()) {
    // Identify the user
    clarity.identify('USER_ID', { userProperty: personId });
  }
};

export const setClaritySessionId = (personId: number) => {
  const date = getLocalDateString(new Date(), false);
  const customSessionId = `${personId}_${date}_${TokenService.getToken()}`;

  clarity.setTag('sessionId', customSessionId);
};

export const setClarityCustomTags = async (prop: any) => {
  const parsedProperties = Object.keys(prop).map((key) => ({
    name: key,
    value: prop[key],
  }));

  parsedProperties.forEach(async (property) => {
    if (property.value) {
      clarity.setTag(property.name, property.value);
    }
  });
};